<template>
  <div>content copy to dashboard</div>
</template>

<script>
export default {};
</script>

<style></style>
